"use strict";

var _classCallCheck = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GrpcConnection = void 0;

var grpc_web_1 = require("@improbable-eng/grpc-web");

var context_1 = require("@textile/context");

var grpc_transport_1 = require("@textile/grpc-transport");

var GrpcConnection = /*#__PURE__*/function () {
  /**
   * Creates a new gRPC client instance for accessing the Textile Buckets API.
   * @param context The context to use for interacting with the APIs. Can be modified later.
   */
  function GrpcConnection() {
    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new context_1.Context();
    var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, GrpcConnection);

    this.context = context;
    var transport = grpc_transport_1.WebsocketTransport(); // Default to websocket always

    this.serviceHost = context.host;
    this.rpcOptions = {
      transport: transport,
      debug: debug
    }; // Set default transport to websocket "globally"

    grpc_web_1.grpc.setDefaultTransport(transport);
  }

  _createClass(GrpcConnection, [{
    key: "unary",
    value: function unary(methodDescriptor, req, ctx) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        var metadata = ctx ? Object.assign({}, ctx.toJSON()) : Object.assign({}, _this.context.toJSON());
        grpc_web_1.grpc.unary(methodDescriptor, {
          request: req,
          host: _this.serviceHost,
          transport: _this.rpcOptions.transport,
          debug: _this.rpcOptions.debug,
          metadata: metadata,
          onEnd: function onEnd(res) {
            var status = res.status,
                statusMessage = res.statusMessage,
                message = res.message;

            if (status === grpc_web_1.grpc.Code.OK) {
              if (message) {
                resolve(message);
              } else {
                resolve();
              }
            } else {
              var err = {
                message: statusMessage,
                code: status,
                metadata: metadata
              };
              reject(err);
            }
          }
        });
      });
    }
  }]);

  return GrpcConnection;
}();

exports.GrpcConnection = GrpcConnection;